/**
 * Props for the DataTableV2ColumnOrderSettings component.
 * @public
 */
export interface DataTableV2ColumnOrderSettingsProps {
  /**
   * Column order reset state that will be used to reset and also to enable/disable 'Reset to default'
   * in column settings modal.
   */
  resetColumnOrder?: string[];
}

/**
 * The slot component serves the sole purpose of detecting the user's intention to display column order within the column settings modal, situated in the DataTableV2 toolbar.
 * @public
 */
export const DataTableV2ColumnOrderSettings = ({
  resetColumnOrder,
}: DataTableV2ColumnOrderSettingsProps) => null;

DataTableV2ColumnOrderSettings.displayName = 'DataTableV2.ColumnOrderSettings';
